var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeezerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "deezer-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.578,
    height: 28.408,
    viewBox: "0 0 148.578 28.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M234.1,18.9c0,5.958,3.67,9.524,9.123,9.524,2.719,0,5.007-.758,6.285-2.749v2.749h4.977V.044h-5.171V12.109c-1.174-1.991-3.343-2.882-6.062-2.882C237.933,9.211,234.1,12.851,234.1,18.9Zm15.378,0c0,3.4-2.318,5.527-5.1,5.527-2.882,0-5.1-2.125-5.1-5.527,0-3.462,2.229-5.631,5.1-5.631C247.16,13.267,249.478,15.466,249.478,18.9Zm21.1,2.2a4.163,4.163,0,0,1-4.457,3.3c-2.749,0-5.007-1.664-5.067-4.606h13.03a10.653,10.653,0,0,0,.238-2.348c0-5.275-3.6-8.246-8.9-8.246a9.16,9.16,0,0,0-9.554,9.494c0,6.092,4.294,9.747,10.237,9.747,4.487,0,7.533-1.872,8.87-5.6Zm-9.524-4.755a4.306,4.306,0,0,1,4.383-3.373c2.318,0,3.893,1.248,3.893,3.209l-.03.163ZM289.757,21.1a4.163,4.163,0,0,1-4.457,3.3c-2.749,0-5.007-1.664-5.067-4.606h13.03a10.651,10.651,0,0,0,.238-2.348c0-5.275-3.6-8.246-8.9-8.246a9.16,9.16,0,0,0-9.554,9.494c0,6.092,4.294,9.747,10.237,9.747,4.487,0,7.533-1.872,8.87-5.6Zm-9.524-4.755a4.306,4.306,0,0,1,4.383-3.373c2.318,0,3.893,1.248,3.893,3.209l-.03.163Zm31.513,12.109v-4.68H300.886L311.45,13.49V9.211H294.735v4.457h10.207L294.408,23.995v4.457Zm15.11-7.355a4.163,4.163,0,0,1-4.457,3.3c-2.749,0-5.007-1.664-5.067-4.606h13.03a10.653,10.653,0,0,0,.238-2.348c0-5.275-3.6-8.246-8.9-8.246a9.16,9.16,0,0,0-9.554,9.494c0,6.092,4.294,9.747,10.237,9.747,4.487,0,7.533-1.872,8.87-5.6Zm-9.524-4.755a4.306,4.306,0,0,1,4.383-3.373c2.318,0,3.893,1.248,3.893,3.209l-.03.163Z",
    transform: "translate(-199.318 -0.044)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(0 9.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M155.5,61.744h6.374v3.729H155.5Z",
    transform: "translate(-132.396 -61.744)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M155.5,9.7h6.374v3.729H155.5Z",
    transform: "translate(-132.396 -4.529)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M155.5,44.5h6.374v3.729H155.5Z",
    transform: "translate(-132.396 -34.159)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M0,79.3H6.374v3.729H0Z",
    transform: "translate(0 -63.788)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M51.8,79.3h6.374v3.729H51.8Z",
    transform: "translate(-44.104 -63.788)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M103.7,79.3h6.374v3.729H103.7Z",
    transform: "translate(-88.292 -63.788)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M155.5,79.3h6.374v3.729H155.5Z",
    transform: "translate(-132.396 -63.788)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M103.7,44.5h6.374v3.729H103.7Z",
    transform: "translate(-88.292 -34.159)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M51.8,44.5h6.374v3.729H51.8Z",
    transform: "translate(-44.104 -34.159)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M51.8,9.7h6.374v3.729H51.8Z",
    transform: "translate(-44.104 -4.529)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M907.011,68.556v.55h5.037V67.635c0-3.3-2.065-5.691-5.527-5.691a4.773,4.773,0,0,0-4.621,2.882V61.944h-5.2V81.155h5.2V68.779c0-1.961,1.055-3.046,2.674-3.046A2.657,2.657,0,0,1,907.011,68.556Z",
    transform: "translate(-763.47 -52.747)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezerLogo);
export default __webpack_public_path__ + "static/media/deezer-logo.1634b5b3b84340a3046668e1b5e7ac1c.svg";
export { ForwardRef as ReactComponent };